<template>
  <div class="exchange-form-side-container">
    <div
      v-if="$scopedSlots.top || !withoutTopSpace"
      class="exchange-form-side-container__top"
    >
      <slot name="top" />
    </div>
    <div class="exchange-form-side-container__content">
      <slot name="content" />
    </div>
    <div class="exchange-form-side-container__bottom">
      <slot name="bottom" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExchangeFormSideContainer',
  props: {
    withoutTopSpace: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.exchange-form-side-container {
  &__top {
    min-height: toRem(36px);
    display: flex;
    align-items: center;
  }
}
</style>
